<template>
  <div :key="forceReRenderKey" class="copy-to-clipboard-text">
    <div class="d-flex align-items-center justify-content-start">
      <textarea
          ref="copyVal"
          :value="value"
          class="copy-item"
          readonly
          rows="1"
      ></textarea>
      <div v-html="value" ref="ghost" class="ghost d-inline-block"></div>
      <div :class="['clickable lighter d-inline-block copy-icon', 'icon-' + copyIconPosition]" @click="copyValToClipboard">
        <icon type="copy"/>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  name: "CopyToClipboardText" ,
  components: {Icon},
  props: {
    value: {type: String, required: true},
    copyIconPosition: {type: String, default: 'right'}
  },
  data() {
    return {
      copied: false,
      forceReRenderKey: 0
    };
  },
  methods: {
    copyValToClipboard() {
      const html = this.$refs.copyVal.value; // contains "<b>..</b>" etc.

      const onCopy = (e) => {
        e.preventDefault();
        e.clipboardData.setData("text/plain", html);      // optional
        e.clipboardData.setData("text/html", html);       // the key!
      };

      document.addEventListener("copy", onCopy);
      document.execCommand("copy");
      document.removeEventListener("copy", onCopy);

      this.copied = true;
      this.$store.dispatch("createNotification", { text: this.$t("valueCopiedToClipboard") });
      setTimeout(() => (this.copied = false), 2000);
    }
  },
}
</script>

<style lang="scss">
.copy-icon {
  margin-top: -2px;
  &.icon-top-right {
    position: absolute;
    top: 2px;
    right: 2px;
  }
  &.icon-bottom-right {
    position: absolute;
    bottom: 2px;
    right: 2px;
  }
}
.copy-item {
  opacity: 0;
  position: fixed;
  top: -9999px;
  left: -9999px;
  background-color: transparent;
  color: #fff;
  border-color: transparent;
  padding-left:0;
  user-select: none;
  pointer-events: none;
  word-wrap: break-word;       /* Old school */
  overflow-wrap: break-word;   /* New school */
  resize: none;
  overflow: hidden;
  flex: 1;
  max-width: 90%;
  &:focus, &:focus-visible {
    outline: none;
  }
}
.copy-to-clipboard-text {
  position: relative;
  .copy-item {
    opacity: 0;
  }
  &.dark {
    .copy-item {
      color: #000;
    }
  }
}
.ghost {
  font: inherit;
  overflow-wrap: break-word; /* modern & nice */
  word-break: break-word;
  display: block;
  width: 90%;
}
</style>